import deepmerge from 'deepmerge';

export const TRANSLATION_FILE_NAMES = [
  'translations-boka.json',
  'translations-contact-form.json',
];

const getTranslationUrl = (
  country: string,
  language: string,
  target: string,
  filename: string,
): string => {
  const host = target === 'prod' ? 'www.ikea.com' : 'www.cte.ikeadt.com';
  return `https://${host}/${country}/${language}/appointment/translations/${filename}`;
};

const fetchTranslationFile = async (
  url: string,
): Promise<Record<string, unknown>> => {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to load translations: ${response.status}`);
  }

  const data = await response.json();
  // Reject translation files deployed before this app build (stale translations)
  if (!data.timestampBokaDeploy || data.timestampBokaDeploy < TIMESTAMP) {
    throw new Error('Translation file is outdated');
  }
  return data;
};

// Fetches the latest translations from CDN when the app loads in the browser.
// Loads multiple translation files and merges them client-side.
export const loadTranslations = async (
  country: string,
  language: string,
  target: string = 'ppe',
): Promise<Record<string, unknown>> => {
  const translationPromises = TRANSLATION_FILE_NAMES.map((filename) => {
    const url = getTranslationUrl(country, language, target, filename);
    return fetchTranslationFile(url);
  });

  const translationFiles = await Promise.all(translationPromises);

  // Deep merge all translation files into a single object
  return translationFiles.reduce((merged, translations) =>
    deepmerge(merged, translations),
  );
};
